import { logger } from 'monitor';
import posthog from 'posthog-js';

import type { UserInfo } from '../types/userInfo';
import { initAnalytics } from './initAnalytics';

export const identifyUser = (userId: string, userInfo: UserInfo) => {
  logger.debug('Identifying analytics user', { userId, userInfo });

  if (!posthog.__loaded) {
    initAnalytics();
  }

  if (userInfo.is_impersonated) {
    logger.info('User is impersonated, disabling analytics');
    posthog.opt_out_capturing();
    return;
  } else {
    posthog.opt_in_capturing();
  }
  posthog.identify(userId, userInfo);
};
